import { Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';

const ContactSection = () => {
  const { language } = useLanguage();
  const t = translations[language].contact;
  
  return (
    <section id="kapcsolat" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-[#7B2F3D] font-semibold text-sm uppercase tracking-widest">{t.badge}</span>
          <h2 className="text-4xl font-bold mt-3 text-gray-900">
            {t.title}
          </h2>
          <p className="text-gray-600 mt-4">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-xl p-8 text-center border border-gray-200">
            <div className="w-14 h-14 mx-auto rounded-lg bg-[#7B2F3D] flex items-center justify-center mb-4">
              <Phone className="w-7 h-7 text-white" />
            </div>
            <p className="text-sm text-gray-500 uppercase tracking-wide mb-2">{t.handyman}</p>
            <a href="tel:+36702378089" className="text-2xl font-bold text-[#7B2F3D] hover:text-[#8B3A3A]">
              06/70-237-8089
            </a>
          </div>

          <div className="bg-gray-50 rounded-xl p-8 text-center border border-gray-200">
            <div className="w-14 h-14 mx-auto rounded-lg bg-[#7B2F3D] flex items-center justify-center mb-4">
              <Phone className="w-7 h-7 text-white" />
            </div>
            <p className="text-sm text-gray-500 uppercase tracking-wide mb-2">{t.it}</p>
            <a href="tel:+36702701639" className="text-2xl font-bold text-[#7B2F3D] hover:text-[#8B3A3A]">
              06/70-270-1639
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;